export default __webpack_public_path__ + "static/media/skelascent.db115ade.png";